import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";

import webp from "../../store/webp/reducers";
import user from "../../store/user/reducers";
import notifications from "../../store/notification/reducers";

export default (history?: History) => combineReducers({
    webp,
    notifications,
    user,
    ...(history && { router: connectRouter(history) }),
});
